import React from "react";
import clsx from "clsx";
import { CopyToCliboard } from "@components/CustomTable/helpers";
import {
  NULL_VALUE,
  SINGLE_RECORD,
  TEXT_COLORS,
  FIRST_ELEMENT,
  SECOND_ELEMENT,
  TOOLTIP_TIMEOUT,
} from "./constants";
import {
  createMismatchesColumn,
  createMatchingSourceColumn,
  createBusinessDayColumn,
  createCreationDateColumn,
  createRecordMatchingKeysColumn,
  createSharedChildrenColumns,
} from "../shared/columnDefinitions";

export const createMainColumns = (translate) => [
  createMismatchesColumn(translate),
  createMatchingSourceColumn(translate),
  createBusinessDayColumn(translate),
  createCreationDateColumn(translate),
  createRecordMatchingKeysColumn(translate),
  {
    accessorKey: "SourceAmount",
    header: translate("exception-details.columns.SourceAmount"),
    size: 70,
    sortable: true,
    canPin: true,
    canFilter: false,
    filterType: "string",
    operator: "EQ",
    processFilterValue: (value, row) => {
      return row.SourceAmount.toString();
    },
    cellActionCheck: (value) => value > NULL_VALUE,
    cell: ({ row }) => {
      const { FormatWithCommas } = require("@helpers/helpers");
      return (
        row.original.SourceAmount && (
          <span className="flex flex-col items-center justify-center group font-normal">
            <span>{`${row.original.Currency} ${FormatWithCommas(
              row.original.SourceAmount
            )}`}</span>
            <span className="font-normal text-xs">{`${
              row.original.SourceRecords.length
            } ${
              row.original.SourceRecords.length === SINGLE_RECORD
                ? translate("shared.record")
                : translate("shared.records")
            }`}</span>
          </span>
        )
      );
    },
  },
  {
    accessorKey: "DestinationAmount",
    header: translate("exception-details.columns.DestinationAmount"),
    size: 60,
    sortable: true,
    canPin: true,
    canFilter: false,
    filterType: "string",
    operator: "EQ",
    filterCheck: (value) => {
      return value !== null;
    },
    cellActionCheck: (value) => value > NULL_VALUE,
    cell: ({ row }) => {
      const { FormatWithCommas } = require("@helpers/helpers");
      return (
        row.original.DestinationAmount && (
          <span className="flex flex-col items-center justify-center group font-normal">
            <span>{`${row.original.Currency} ${FormatWithCommas(
              row.original.DestinationAmount
            )}`}</span>
            <span className="font-normal text-xs">{`${
              row.original.DestinationRecords.length
            } ${
              row.original.DestinationRecords.length === SINGLE_RECORD
                ? translate("shared.record")
                : translate("shared.records")
            }`}</span>
          </span>
        )
      );
    },
  },
];

export const createChildrenColumns = (translate, setAttributesPopupOpen, setCurrentTooltip) => {
  const sharedColumns = createSharedChildrenColumns(translate, setCurrentTooltip);
  return sharedColumns;
};
